import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSun, faMoon } from '@fortawesome/free-solid-svg-icons';

const DarkMode = ({ theme, updateTheme }) => {
  //const prefersDarkMode = window.matchMedia("(prefers-color-scheme: dark)").matches;

  //const [theme, setTheme] = useState(
  //  localStorage.getItem("theme") ? localStorage.getItem("theme") : (prefersDarkMode ? "dark" : "dark")
  //);
  //const [theme, setTheme] = useState(localStorage.getItem("theme") || "dark");

  //const [theme, setTheme] = useState('dark');

  /*const updateTheme = () => {
    const newTheme = theme === "dark" ? "light" : "dark";
    setTheme(newTheme);
    localStorage.setItem("theme", newTheme);
    onThemeChange(newTheme);  // Notify parent component
};*/

  useEffect(() => {
    const element = document.documentElement;
    element.classList.toggle("dark", theme === "dark");
  }, [theme]);

  return (
    <div className="relative">
      {theme === "light" ? (
        <FontAwesomeIcon
          icon={faSun}
          className="text-2xl cursor-pointer"
          onClick={updateTheme}
          title="Cambiar a Modo Oscuro"
        />
      ) : (
        <FontAwesomeIcon
          icon={faMoon}
          className="text-2xl cursor-pointer"
          onClick={updateTheme}
          title="Cambiar a Modo Claro"
        />
      )}
    </div>
  );
};

export default DarkMode;